import React, { CSSProperties } from 'react';
import './Icon.less';
import MdiIcon from '@mdi/react';
import {
    mdiRobotHappy,
    mdiAccount,
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiArchiveOutline,
    mdiCloudUploadOutline,
    mdiArrowRight,
    mdiArrowUp,
    mdiAt,
    mdiBellRingOutline,
    mdiCalendar,
    mdiCamera,
    mdiCameraOff,
    mdiChartAreaspline,
    mdiCheck,
    mdiCheckboxBlankCircleOutline,
    mdiCheckCircle,
    mdiCheckCircleOutline,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiClipboardOutline,
    mdiClose,
    mdiCloseOctagonOutline,
    mdiContrastCircle,
    mdiCreation,
    mdiDelete,
    mdiDiameterVariant,
    mdiDotsVertical,
    mdiEye,
    mdiHelpCircle,
    mdiImage,
    mdiImageMove,
    mdiInformationOutline,
    mdiLockClock,
    mdiMenu,
    mdiMenuDown,
    mdiMenuUp,
    mdiMinus,
    mdiMinusBoxOutline,
    mdiPencil,
    mdiPlus,
    mdiPlusBoxOutline,
    mdiProgressClock,
    mdiQrcodeScan,
    mdiRefreshCircle,
    mdiSelectGroup,
    mdiShare,
    mdiSortAscending,
    mdiSortDescending,
    mdiAlertRhombusOutline,
    mdiTranslate,
    mdiSortAlphabeticalAscending,
    mdiSortNumericAscending,
    mdiTrashCanOutline,
    mdiUndo,
    mdiVolumeOff,
    mdiVolumeHigh,
} from '@mdi/js';
import classNames from 'classnames';
import { EnvagoAria } from '../../../aria.types';

interface Props {
    className?: string;
    path: string;
    size?: number | string;
    style?: CSSProperties;
    aria?: EnvagoAria;
}

const Icon = ({ path, className, size, style, aria }: Props) => {
    return <MdiIcon className={classNames(className, 'icon')} path={path} size={size} style={style} {...aria} />;
};

Icon.Path = {
    mdiAccount,
    mdiRobotHappy,
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiArchiveOutline,
    mdiCloudUploadOutline,
    mdiArrowRight,
    mdiArrowUp,
    mdiAt,
    mdiBellRingOutline,
    mdiCalendar,
    mdiCamera,
    mdiCameraOff,
    mdiChartAreaspline,
    mdiCheck,
    mdiCheckCircle,
    mdiCheckCircleOutline,
    mdiCheckboxBlankCircleOutline,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiClipboardOutline,
    mdiClose,
    mdiCloseOctagonOutline,
    mdiDelete,
    mdiDiameterVariant,
    mdiDotsVertical,
    mdiEye,
    mdiHelpCircle,
    mdiImage,
    mdiImageMove,
    mdiInformationOutline,
    mdiLockClock,
    mdiMenu,
    mdiMenuDown,
    mdiMenuUp,
    mdiMinus,
    mdiMinusBoxOutline,
    mdiPencil,
    mdiPlus,
    mdiPlusBoxOutline,
    mdiProgressClock,
    mdiQrcodeScan,
    mdiRefreshCircle,
    mdiSelectGroup,
    mdiShare,
    mdiSortAscending,
    mdiSortDescending,
    mdiContrastCircle,
    mdiCreation,
    mdiAlertRhombusOutline,
    mdiTranslate,
    mdiSortAlphabeticalAscending,
    mdiSortNumericAscending,
    mdiTrashCanOutline,
    mdiUndo,
    mdiVolumeOff,
    mdiVolumeHigh,
};

export default Icon;
